<template>
  <Menu
    as="div"
    class="relative z-30 inline-block text-left"
  >
    <MenuButton>
      <ButtonComponent
        :disabled="isDisabled"
        class="!pl-3"
      >
        <img
          src="@/assets/sort-carots.svg"
          alt="sort icon"
        />
        Sort
      </ButtonComponent>
    </MenuButton>

    <transition
      enter-active-class="transition duration-100 ease-out"
      enter-from-class="transform scale-95 opacity-0"
      enter-to-class="transform scale-100 opacity-100"
      leave-active-class="transition duration-75 ease-in"
      leave-from-class="transform scale-100 opacity-100"
      leave-to-class="transform scale-95 opacity-0"
    >
      <MenuItems
        class="load-sort-container absolute -right-2 mt-2 w-52 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black/5 focus:outline-none"
      >
        <MenuItem class="p-3">
          <span @click="handleSort('best')">
            <p
              class="flex cursor-pointer gap-2 p-3 text-steel-900 hover:bg-steel-100"
              :class="{
                'bg-sun-100': currentSort === 'best',
              }"
            >
              Best Match
            </p>
          </span>
        </MenuItem>
        <MenuItem class="p-3">
          <span @click="handleSort('rpm')">
            <p
              class="flex cursor-pointer gap-2 p-3 text-steel-900 hover:bg-steel-100"
              :class="{
                'bg-sun-100': currentSort === 'rpm',
              }"
            >
              RPM (Highest)
            </p>
          </span>
        </MenuItem>
        <MenuItem class="p-3">
          <span @click="handleSort('pickup')">
            <p
              class="flex cursor-pointer gap-2 p-3 text-steel-900 hover:bg-steel-100"
              :class="{
                'bg-sun-100': currentSort === 'pickup',
              }"
            >
              Pickup Date (Earliest)
            </p>
          </span>
        </MenuItem>
        <MenuItem class="p-3">
          <span @click="handleSort('posting_desc')">
            <p
              class="flex cursor-pointer gap-2 p-3 text-steel-900 hover:bg-steel-100"
              :class="{
                'bg-sun-100': currentSort === 'posting_desc',
              }"
            >
              Load Age (Newest)
            </p>
          </span>
        </MenuItem>
        <MenuItem class="p-3">
          <span @click="handleSort('price_desc')">
            <p
              class="flex cursor-pointer gap-2 p-3 text-steel-900 hover:bg-steel-100"
              :class="{
                'bg-sun-100': currentSort === 'price_desc',
              }"
            >
              Rate (Highest)
            </p>
          </span>
        </MenuItem>
        <MenuItem class="p-3">
          <span @click="handleSort('distance_asc')">
            <p
              class="flex cursor-pointer gap-2 p-3 text-steel-900 hover:bg-steel-100"
              :class="{
                'bg-sun-100': currentSort === 'distance_asc',
              }"
            >
              Trip Distance (Shortest)
            </p>
          </span>
        </MenuItem>
        <MenuItem class="p-3">
          <span @click="handleSort('distance_desc')">
            <p
              class="flex cursor-pointer gap-2 p-3 text-steel-900 hover:bg-steel-100"
              :class="{
                'bg-sun-100': currentSort === 'distance_desc',
              }"
            >
              Trip Distance (Longest)
            </p>
          </span>
        </MenuItem>
      </MenuItems>
    </transition>
  </Menu>
</template>

<script setup>
import { computed } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import { Menu, MenuButton, MenuItems, MenuItem } from '@headlessui/vue';
import { ButtonComponent } from '@/components';

const store = useStore();
const router = useRouter();

defineProps({
  isDisabled: Boolean,
});

const currentSort = computed(
  () => router.currentRoute.value.query?.sort || 'best'
);

const handleSort = (selected) => {
  const existingQueries = router.currentRoute.value.query;

  if (currentSort?.value !== selected) {
    store.commit('loads/setLoading', true);

    const query = {
      ...existingQueries,
      sort: selected,
    };
    if (selected === 'best') {
      delete query.sort;
    }

    router.push({
      query,
    });
  }
};
</script>

<style>
.load-sort-container span {
  all: unset;
}
</style>
